module.exports = __webpack_public_path__ + "assets/a62da7c1859f7e27da253fbd98a18702.mp3";